export default __webpack_public_path__ + "static/media/icon_arrow-opposite.3875f49c.svg";